<div class="toast">
  <article *ngFor="let message of _messages; let i = index;" [ngClass]="{'close': toRemove === i, 'end': closeAnimation}"
    class="{{message.class}}">
    <p [innerHTML]="transformMessage(message.message) | translate"></p><i class="fas fa-times" title="{{'global.cerrar' | translate}}"
      (click)="toRemove = i; close()"></i>
  </article>
</div>
